<div class="form-container" *ngIf="!isPasswordSet">
  <!-- password change section  -->
  <div class="inner-container-wrapper">
    <div class="titletext">
      {{'RESET_PASSWORD.TITLE_ENTER_NEW_PASSWORD' | translate}}
    </div>
    <p class="peratext-light pt16"> {{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_CHANGE_PROCEDURE' | translate}}
    </p>
    <div class="form_wrapper">
    <form id="passwordForm" class="custom-form" [formGroup]="resetPwdForm" (ngSubmit)="checkValidUser()" autocomplete="off" name="form" #changePwdForm="ngForm">
      <!-- <div class="form-group">
        <input type="password" name="newPassword" class="form-control cp-input" placeholder="Password"
          pattern="(?=^.{8,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;'?\/&gt;.&lt;,])(?!.*\s).*$"
          [(ngModel)]="model.newPassword" #newPassword="ngModel" (input)="checkPasswordStrength();" maxlength="20"
          (focusout)="checkPasswords();" (focus)="isPasswordWeak=true"
          [ngClass]="{ 'is-invalid': changePwdForm.submitted && newPassword.invalid }" formControlName="newPassword" required (keyup)="check();" />
        <div *ngIf="(changePwdForm.submitted && newPassword.invalid) || newPassword.hasError('pattern')"
          class="error-message">
          <div *ngIf="newPassword.hasError('pattern')">{{'ERROR_CODE.INVALID' | translate}}</div>
          <div *ngIf="newPassword.errors.required">{{'ERROR_CODE.REQ' | translate}}</div>
        </div>
      </div> -->

      <div class="input-control w-336 input-error-wrapper">
        <!-- <label class="label" for="name">New Password</label> -->
        <div class="input-cont">
          <input [ngClass]="(!isPasswordWeak && passwordRef.value) ? 'border-red': ''" autocomplete="off"
          [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword" class="control"
              (input)="checkPasswordStrength();"  placeholder="Password"
              (focusout)="onFocusLoose();checkPasswords();"
              (focus)="isPasswordWeak=true"
              maxlength="20" formControlName="newPassword" required
              appNoWhitespace #passwordRef>
              <!-- <span class="show" (click)="toggleShowNew();" id="showHide">{{ showNewPassword ? 'HIDE' : 'SHOW'}}</span> -->
            </div>
          <!-- <img *ngIf="(!isPasswordWeak && passwordRef.value)"
          src="../../../../../../../assets/images/cp-images/warning_icon.svg" width="15px" height="15px" />
          <img *ngIf="(resetPwdForm.controls.newPassword.errors?.whitespace || resetPwdForm.controls.newPassword.errors?.required) && resetPwdForm.controls.newPassword.invalid && (resetPwdForm.controls.newPassword.touched)"
          src="../../../../../../../assets/images/cp-images/warning_icon.svg" width="15px" height="15px" /> -->
          <div class="text-red"
            *ngIf="(resetPwdForm.controls.newPassword.errors?.whitespace || resetPwdForm.controls.newPassword.errors?.required) && resetPwdForm.controls.newPassword.invalid && (resetPwdForm.controls.newPassword.touched)">
            Fill-in the field
        </div>
          <div class="text-red" *ngIf="(!isPasswordWeak && passwordRef.value)">Password didn't meet the requirements.
              Try again.</div>
      </div>



      <!-- <div class="form-group">
        <input type="password" formControlName="confirmPassword" class="form-control cp-input" placeholder="Confirm password" name="confirmPassword"
          [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" maxlength="20"  (input)="checkPasswords();" 
          [ngClass]="{ 'is-invalid': changePwdForm.submitted && confirmPassword.invalid }" required #cnfpwdRef />
        <div *ngIf="changePwdForm.submitted && confirmPassword.invalid" class="error-message">
          <div *ngIf="confirmPassword.errors.required">{{'ERROR_CODE.REQ' | translate}}</div>
        </div>
        <div *ngIf="!isPasswordMatched && cnfpwdRef.value" class="error-message"
          [innerHTML]="'RESET_PASSWORD.UPDATE_PWD.PWD_NO_MATCH' | translate">
        </div>
      </div> -->
      <div class="input-control w-336 input-error-wrapper">
        <!-- <label class="label" for="name">Confirm New Password</label> -->
        <div class="input-cont">
          <input [ngClass]="(!isConfirmPassword && cnfpwdRef.value) ? 'border-red': ''" autocomplete="off"
          [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword" class="control" id="confirmPassword"
          placeholder="Confirm password"
              (input)="checkPasswords();" formControlName="confirmPassword" maxlength="20" appNoWhitespace #cnfpwdRef>
              <!-- <span class="show" (click)="toggleShowConfirm();" id="showHide">{{ showConfirmPassword ? 'HIDE' : 'SHOW'}}</span> -->
            </div>
          <!-- <img *ngIf="(!isConfirmPassword && cnfpwdRef.value)"
          src="../../../../../../../assets/images/cp-images/warning_icon.svg" width="15px" height="15px" /> -->
          <div class="text-red" *ngIf="!isConfirmPassword && cnfpwdRef.value">
              Confirm password didn't match.
          </div>
          <!-- <img *ngIf="(resetPwdForm.controls.confirmPassword.errors?.whitespace || resetPwdForm.controls.confirmPassword.errors?.required) && resetPwdForm.controls.confirmPassword.invalid && (resetPwdForm.controls.confirmPassword.touched)"
          src="../../../../../../../assets/images/cp-images/warning_icon.svg" width="15px" height="15px" /> -->
          <div class="text-red"
            *ngIf="(resetPwdForm.controls.confirmPassword.errors?.whitespace || resetPwdForm.controls.confirmPassword.errors?.required) && resetPwdForm.controls.confirmPassword.invalid && (resetPwdForm.controls.confirmPassword.touched)">
            Fill-in the field
        </div>
      </div>

    <div class="pwdp-wrapper pt24">
      <span [ngClass]="!isMinlength ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_1' | translate}}</span>
      <span [ngClass]="!isLowerCase ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_2' | translate}}</span>
      <span [ngClass]="!isUpperCase ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_3' | translate}} </span>
      <span [ngClass]="!isOneDigit ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_4' | translate}}</span>
      <span [ngClass]="(!isSpecialChar || !wholePassword ? 'disabled': '')">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_5' | translate}}</span>
    </div>
    
      <span class="bktologin pt24" (click)="helperService.goToOnlineBankingApp()"> {{'RESET_PASSWORD.UPDATE_PWD.BACK_TO_LOGIN' | translate}} </span>
      <!-- <button class="cp-btn cp-btn-primary" [disabled]="(changePwdForm.form.valid && !isPasswordMatched && cnfpwdRef.value)" (click)="setPassword()">{{'RESET_PASSWORD.UPDATE_PWD.BTN_UPDATE_PASSWORD' | translate}}</button> -->
      <button class="cp-btn cp-btn-primary cp-mt-24"  [attr.disabled]="(invalidPassword && isConfirmPassword && cnfpwdRef.value) ? null: 'true'"
      type="submit">
      {{'RESET_PASSWORD.UPDATE_PWD.BTN_UPDATE_PASSWORD' | translate}}</button>
   
  </form>
  </div>
  </div>
</div>

<!-- <div class="div-container" *ngIf="isPasswordSet">
  <div>{{'RESET_PASSWORD.UPDATE_PWD.GO_TO' | translate}} <a href="{{bankingUrl}}" target="_blank">
      {{'RESET_PASSWORD.UPDATE_PWD.ONL_BANKING' | translate}}</a>.</div>
</div> -->